import { stringify as qs_stringify } from 'qs'
/* 接口调用新方式 hapis */
import ajax from '@common/libs/util.ajax.js'
import Env from '@common/libs/util.env.js'
import { getQueryString } from '@common/libs/util.url.js'
import DIDA_SDK from '@common/libs/util.didasdk.js'

var longitude = '116.403847'
var latitude = '39.915526'
const minilon = getQueryString('lon') || '116.403847'
const minilat = getQueryString('lat') || '39.915526'
// const CID =
// getQueryString('cid') ||
// getQueryString('user_cid') ||
// getQueryString('userCid') ||
// getQueryString('encrypted_cid') ||
// sessionStorage.getItem('user_cid') ||
// ''
if (Env.inApplication) {
  // app 内
  DIDA_SDK.ready(() => {
    DIDA_SDK.callHandler('getLocation', {}).then(res => {
      if (res) {
        const obj = JSON.parse(res) || {}
        longitude = obj.lng || '116.403847'
        latitude = obj.lat || '39.915526'
      }
    }).catch(() => { })
  })
} else {
  // 非app，小程序一进入跳下载页，不用过多判断
  latitude = minilat
  longitude = minilon
}
function getNowtime () {
  const date = new Date()
  const yyyy = fomatTime(date.getFullYear())
  const MM = fomatTime(date.getMonth() + 1)
  const dd = fomatTime(date.getDate())
  const hh = fomatTime(date.getHours())
  const mm = fomatTime(date.getMinutes())
  const ss = fomatTime(date.getSeconds())
  return yyyy + MM + dd + hh + mm + ss
}

function fomatTime (num) {
  if (num < 10) {
    return '0' + num
  } else {
    return num.toString()
  }
}

let domainName
// let oldDomainName
if (location.host.includes(':') && /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/.test(location.host.split(':')[0]) || location.host.includes('localhost')) {
  domainName = ''
  // oldDomainName = ''
} else {
  if (Env.isEnvOnline) {
    domainName = 'https://capis.didapinche.com'
    // oldDomainName = 'https://www.didapinche.com'
  } else if (Env.isEnvECS) {
    domainName = 'https://capis-ecs.didapinche.com'
    // oldDomainName = 'https://www-ecs.didapinche.com'
  } else {
    domainName = 'https://capis-ecs.didapinche.com'
    // oldDomainName = 'https://www-ecs.didapinche.com'
  }
}

/* 格式化thrift返回值 JSON.parse(res.body.ret) */
function formatTChannelData (res, parseRet = true) {
  res = res || {}
  // res.body = res.body || {};
  if (parseRet && res.ret) {
    try {
      res.ret = JSON.parse(res.ret)
    } catch (e) {
      console.log('e===>', e)
    }
  }
  const { ret, code = 0, msg } = res

  return {
    code,
    message: msg || 'ok',
    data: {
      code,
      message: msg || 'ok',
      ret
    }
  }
}

// 发送验证码
export function sendCode (mobile) {
  return ajax.post(domainName + '/web/user/sendCode', qs_stringify({
    actid: 'h5',
    mpno: mobile
  }), {
    ddcinfo: {
      // mobiletype: ''
      identifier: 'couponTemplate.h5',
      latitude: latitude,
      longitude: longitude,
      location_time: getNowtime()
    }
  })
}

// 登录 验证验证码
export function login (code, phone) {
  return ajax.post(domainName + '/web/user/h5/signin', qs_stringify({
    code: code,
    mpno: phone,
    client_id: 'h5',
    source_cid: 'couponTemplate'
  }), {
    ddcinfo: {
      // mobiletype: ''
      identifier: 'couponTemplate.h5',
      latitude: latitude,
      longitude: longitude,
      location_time: getNowtime()
    }
  })
}

// cps领取优惠券页面信息
export function getCouponMsg (data) {
  // return ajax.get(oldDomainName + '/hapis/api/t/Active/getCpsH5CollectCouponPageDetailsV2', {
  //   params: data
  // })
  return ajax.post(
    domainName + '/web/zapi/active/getCpsH5CollectCouponPageDetailsV2',
    (data),
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  ).then(res => formatTChannelData(res.data))
}

// cps领取优惠券页面-领取优惠券
export function receiveCpsH5Coupon (data, access_token) {
  // return ajax.get(oldDomainName + '/hapis/api/t/Active/receiveCpsH5CouponV2', {
  //   params: data,
  //   headers: {
  //     'x-access-token': access_token
  //   }
  // })
  return ajax.post(
    domainName + '/web/zapi/active/receiveCpsH5CouponV3',
    {
      user_cid: data.userCid,
      request: data
    },
    {
      headers: {
        'x-access-token': access_token,
        'Content-Type': 'application/json'
      }
    }
  ).then(res => formatTChannelData(res.data))
}
// cps领取优惠券页面-是否领取过优惠券
export function checkHaveReceive (data, access_token) {
  // return ajax.get(oldDomainName + '/hapis/api/t/Active/checkHaveReceiveCpsH5Coupon', {
  //   params: data,
  //   headers: {
  //     'x-access-token': access_token
  //   }
  // })
  return ajax.post(
    domainName + '/web/zapi/active/checkHaveReceiveCpsH5Coupon',
    (data),
    {
      headers: {
        'x-access-token': access_token,
        'Content-Type': 'application/json'
      }
    }
  ).then(res => formatTChannelData(res.data))
}
// 微信广告渠道领券页数据监测
export function wechatMKT (data) {
  return ajax.get(domainName + '/web/active/wechat/send', {
    params: data
  })
}

// H5 静默登录 accessToken
export function getAccessToken (data) {
  return ajax.post(domainName + '/web/user/login/weiXin/accessToken', qs_stringify(data), {
    ddcinfo: {
      identifier: 'couponTemplate.h5',
      latitude: latitude,
      longitude: longitude,
      location_time: getNowtime()
    }
  })
}

// 公众号免登陆
export function official (data) {
  return ajax.post(domainName + '/web/user/login/weiXin/official', qs_stringify(data), {
    ddcinfo: {
      identifier: 'couponTemplate.h5',
      latitude: latitude,
      longitude: longitude,
      location_time: getNowtime()
    }
  })
}
